export default __webpack_public_path__ + "static/CentraNo2-Medium-78b1a18f068c1ad57c13c51fcb62dd11.woff2";